import { ShellApp } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';

interface ShellCache {
  apps?: ShellApp[];
}

type CachedItem = keyof ShellCache;

export class ShellApi {
  private static shellCache: ShellCache = {};

  public static getApps = async () => {
    const { apps } = ShellApi.shellCache;
    if (apps) {
      return apps;
    }
    const url = `/lcm/shell/api/apps`;
    const response = await Http.get<ShellApp[]>(url);
    ShellApi.shellCache.apps = response.data;
    return response.data;
  };

  public static clearCache() {
    ShellApi.shellCache = {};
  }

  public static clearCachedItem(item: CachedItem) {
    delete ShellApi.shellCache[item];
  }
}
